import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    Footer: {
        fontSize: '0.85rem',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '30px',
        fontStyle: 'italic',
        color: '#9b9b9b',
        display: 'flex'
    }
});

export default function() {
    const classes = useStyles();
    const { t } = useTranslation(['Core']);
    return (
        <div className={`${classes.Footer} no-print`}>
            {t('footer')}
        </div>
    );
}
